import { types as t, getParent } from 'mobx-state-tree';
import PropertyItem from './PropertyItem';

export default t.model("ProductMedia", {
	FileData: t.string,
    SortOrder: t.number,
    Properties: t.optional(PropertyItem, {})
	
}).views(self => ({
    get Product() {
        return getParent(self, 2);
    }

})).actions(self => ({

}));